module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki11_pc-90fb378d8fe89f60def6d9e07e3d0f40.jpg";